import React from "react";
import { useNavigate } from "react-router-dom";
import { isMobileOnly } from "react-device-detect";
import { HeaderDiv, FeedbackAndQuoteContainer } from "./HeaderStyle";

import HeaderImg from "../../assets/Images/Mobile/Header.png";
import TabletHeaderImg from "../../assets/Images/Tablet/Header.png";

const Header: React.FC = () => {
  let navigate = useNavigate();

  return (
    <HeaderDiv>
      <picture>
        <source media="(min-width: 600px)" srcSet={TabletHeaderImg} />
        <img
          src={HeaderImg}
          alt="Digital Person"
          onClick={() => navigate("/")}
        />
      </picture>
      <FeedbackAndQuoteContainer>
        <a
          onClick={() => {
            window.KAMPYLE_ONSITE_SDK.showForm(39838);
          }}
        >
          Send {isMobileOnly && <br />} Feedback
        </a>
        <button
          type="button"
          data-tracking="btn-click:HeaderBeginAQuote"
          onClick={() =>
            window.open(
              "https://www.insuranceonline.nrma.com.au/oss/GTConnect/UnifiedAcceptor/Portal.Quote?intcmp=soul-machine_begin-a-quote",
              "_blank"
            )
          }
        >
          Begin a Quote
        </button>
      </FeedbackAndQuoteContainer>
    </HeaderDiv>
  );
};

export default Header;
